import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LoginComponent } from './login/login.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { ProductSelectionComponent } from './product-selection/product-selection.component';
import { MemberInfoResolver } from './resolvers/member-info.resolver';
import { ProductsResolver } from './resolvers/products.resolver';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'view-eac',
    component: LandingPageComponent,
    canActivate: [AuthGuard],
    resolve: {
      routeResolver: MemberInfoResolver,
    },
  },
  {
    path: 'product-selection',
    component: ProductSelectionComponent,
    canActivate: [AuthGuard],
    resolve: {
      routeResolver: ProductsResolver,
    },
  },
  {
    path: 'pdf-view',
    component: PdfViewerComponent,
    canActivate: [AuthGuard],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
